import { inject, Injectable } from '@angular/core';

import type { IAppConfig } from '@core/common-legacy';
import { APP_CONFIG, AUTH_METHOD, AUTH_TOKEN, LocalStorageService } from '@core/common-legacy';
import { HttpRequestData, IdentityHeader, IdentityHeaders } from '@core/http-types';
import { WindowRef } from '@core/user-interface-legacy';

import { environment } from '../../environments/environment';

@Injectable()
export class ReferralsRequestData extends HttpRequestData {
  private readonly windowRef = inject(WindowRef);
  private readonly localStorageService = inject(LocalStorageService);
  private readonly config = inject<IAppConfig>(APP_CONFIG);
  private readonly authToken = inject<string>(AUTH_TOKEN);
  private readonly subdomain: string;
  public readonly authMethod = inject<string>(AUTH_METHOD);

  constructor() {
    super();
    this.subdomain = environment.resolveSubdomainFromHost
      ? this.resolveSubdomainFromHost()
      : this.promptForSubdomain();
  }

  public buildUrl(path: string): string {
    return `${this.config.apiUrl}/${this.subdomain}` + path;
  }

  public provideAuthHeaders(): { Authorization: string } | {} {
    return this.authMethod && this.authToken
      ? { Authorization: `${this.authMethod} ${this.authToken}` }
      : {};
  }

  public provideIdentityHeaders(): IdentityHeaders {
    return {
      [IdentityHeader.Client]: this.config.isE2e ? 'Referrals - e2e' : 'Referrals',
      [IdentityHeader.Env]: environment.environmentName,
    };
  }

  private resolveSubdomainFromHost(): string {
    const {
      location: { hostname },
    } = this.windowRef.nativeWindow;
    return hostname.split('.')[0];
  }

  private promptForSubdomain(): string {
    const LS_KEY = 'referrals_subdomain';
    const valueFromLS = this.localStorageService.get(LS_KEY);

    if (valueFromLS) {
      return valueFromLS;
    }

    const subdomain = prompt('Type referrals subdomain here')!;
    this.localStorageService.set(LS_KEY, subdomain);

    return subdomain;
  }
}
